module.exports = __webpack_public_path__ + "static/media/skin.26d3b8b5.jpg";